<template>
    <div class='footer'>
        <p>© 2022–2025 The Chinese University of Hong Kong. All rights reserved.</p>
    </div>
</template>
<script>
export default {
};
</script>
<style scoped>
.footer {
  margin-top: 60px;
  margin-bottom: 30px;
  padding: 30px;
  text-align: center;
}
</style>
